module.exports = __webpack_public_path__ + "static/img/AO@2x.6fdd5c3d.jpg";